import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Benefit {
  id: string;
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-benefits',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './benefits.component.html',
  styleUrl: './benefits.component.scss',
})
export class BenefitsComponent {
  benefits: Benefit[] = [
    { id: 'farmers', icon: '/about-us/benefits/Tractor.svg', title: 'Farmers', description: 'Better access to credit, insurance, advisories' },
    { id: 'government', icon: '/about-us/benefits/landmark.svg', title: 'Government', description: 'Unified view, evidence-based policymaking' },
    { id: 'startups', icon: '/about-us/benefits/Factory.svg', title: 'Startups & other Industries', description: 'Trusted data for AI and innovation' },
    { id: 'researchers', icon: '/about-us/benefits/TestTube.svg', title: 'Researchers', description: 'Standardized, governed datasets at scale' },
  ];
}
